var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_interface_add",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-add-circle {\n        fill: currentColor;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add_circle_FILL1_wght400_GRAD0_opsz48",
    className: "cls-add-circle",
    d: "M15.19,22h1.8V17.02H22v-1.8H16.99V10h-1.8v5.22H10v1.8h5.19ZM16,28a11.611,11.611,0,0,1-4.65-.945,12.09,12.09,0,0,1-6.405-6.4,11.987,11.987,0,0,1,0-9.33,11.993,11.993,0,0,1,2.58-3.81A12.3,12.3,0,0,1,11.35,4.945a11.987,11.987,0,0,1,9.33,0,11.981,11.981,0,0,1,6.375,6.375,11.987,11.987,0,0,1,0,9.33,12.3,12.3,0,0,1-2.565,3.825,11.993,11.993,0,0,1-3.81,2.58A11.685,11.685,0,0,1,16,28Z",
    transform: "translate(-4 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.66297e0bdefe49ae305441dc70f50a6f.svg";
export { ForwardRef as ReactComponent };